<template>
  <div id="register-page">
    <el-tabs v-model="activeName">
      <el-tab-pane label="注册新用户" name="register">
        <register-form />
      </el-tab-pane>
      <el-tab-pane label="绑定已有客户" name="bind">
        <bind-customer />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import RegisterForm from './partials/RegisterForm.vue'
import BindCustomer from './partials/BindCustomer.vue'
export default {
  name: 'Register',
  components: {
    RegisterForm,
    BindCustomer
  },
  data () {
    return {
      activeName: 'register'
    }
  }
}
</script>
